import { useState } from 'preact/hooks'
import { useAthosContext } from 'libs/athos/fetchers/provider'
import { useBeaconLogImpressions, useBeaconLogRender } from 'libs/athos/hooks/useBeaconAnalytics'
import { ResultsCard } from 'libs/athos/components/ResultCard'
import { SkeletonCard } from 'libs/athos/components/SkeletonCard'
import clsx from 'clsx'

export function BaseResults({ className, wrapperClassName = '', productCardSettings, renderWrapper, beaconEnabled = true, insideCarousel = false }) {
  const { results, isLoading } = useAthosContext()
  const [node, setNode] = useState()

  // `beaconEnabled: false` holds render/impression while this surface is not
  // the visible one (e.g. an inactive tab in the tabbed carousel) — events fire
  // when it becomes active, so tags always match the profile actually seen.
  useBeaconLogRender({ enabled: beaconEnabled })
  useBeaconLogImpressions(node, { enabled: beaconEnabled })

  if (results?.results?.length === 0 && !isLoading) return null

  const placeholderCount = results?.results?.length || 8
  const items = Array.from({ length: placeholderCount }, (_, index) => ({
    id: index,
    result: results?.results?.[index]
  }))

  const renderSkeletonItems = () => items.map((_, index) => (
    <div className={clsx(className, 'shrink-0')} key={`skeleton-${index}`}>
      <SkeletonCard {...(productCardSettings && { options: productCardSettings })} />
    </div>
  ))

  // No peek here — the hint belongs to the shopper's first PLP/search grid only.
  const renderRealItems = () => items.map(({ id, result }) => (
    <div className={clsx(className, 'shrink-0')} key={result?.handle || id}>
      {result && (
        <ResultsCard
          hideQuickAdd={true}
          result={result}
          dataIndex={id.toString()}
          insideCarousel={insideCarousel}
          {...(productCardSettings && { options: productCardSettings })}
        />
      )}
    </div>
  ))

  const renderGridItems = () => items.map(({ id, result }) => (
    <div className={clsx(className, 'shrink-0')} key={result?.handle || id}>
      {result ? (
        <ResultsCard
          hideQuickAdd={true}
          result={result}
          dataIndex={id.toString()}
          insideCarousel={insideCarousel}
          {...(productCardSettings && { options: productCardSettings })}
        />
      ) : (
        <SkeletonCard {...(productCardSettings && { options: productCardSettings })} />
      )}
    </div>
  ))

  return (
    <div ref={setNode} className={clsx('flex relative w-full', wrapperClassName)}>
      {renderWrapper ? renderWrapper(renderSkeletonItems(), renderRealItems()) : renderGridItems()}
    </div>
  )
}
